import Vue from 'vue';
import App from './App.vue';
import CludoVue from '@universityofbristol/cludo-vue';
import store from './store';

Vue.config.productionTip = false;

Vue.use(CludoVue, {
  store: store,
  options: {
    useQuery: true,
    cludoCustomerId: 2541,
    cludoEngineId: 11571,
    queryStatsEnabled: true,
    clickStatsEnabled: true,
    perPage: 500,
    paginationRange: 2,
    sortOnLoad: { Title: 'asc' },
    // payload: {
    //   filters: {
    //     Category: ['Course'],
    //     StudyLevel: ['Postgraduate'],
    //     StudyYear: ['2025'],
    //   },
    // },
  },
});

new Vue({
  render: (h) => h(App),
  store: store,
}).$mount('#scholarship-search');
